// API functions for webhooks

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export const webhooksApi = {
  // List webhooks
  async list(params = {}) {
    const query = new URLSearchParams(params).toString();
    const response = await fetch(`${API_URL}/api/v1/webhooks/?${query}`);
    return response.json();
  },

  // Get webhook
  async get(id) {
    const response = await fetch(`${API_URL}/api/v1/webhooks/${id}`);
    return response.json();
  },

  // Create webhook
  async create(data) {
    const response = await fetch(`${API_URL}/api/v1/webhooks/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  // Update webhook
  async update(id, data) {
    const response = await fetch(`${API_URL}/api/v1/webhooks/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  // Delete webhook
  async delete(id) {
    const response = await fetch(`${API_URL}/api/v1/webhooks/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },

  // Test webhook
  async test(id, eventType = 'form.submitted') {
    const response = await fetch(`${API_URL}/api/v1/webhooks/${id}/test`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_type: eventType }),
    });
    return response.json();
  },

  // Pause/Activate
  async pause(id) {
    const response = await fetch(`${API_URL}/api/v1/webhooks/${id}/pause`, {
      method: 'POST',
    });
    return response.json();
  },

  async activate(id) {
    const response = await fetch(`${API_URL}/api/v1/webhooks/${id}/activate`, {
      method: 'POST',
    });
    return response.json();
  },

  // Events/Deliveries
  async getEvents(webhookId, params = {}) {
    const query = new URLSearchParams(params).toString();
    const response = await fetch(`${API_URL}/api/v1/webhooks/${webhookId}/events?${query}`);
    return response.json();
  },

  async retryEvent(eventId) {
    const response = await fetch(`${API_URL}/api/v1/webhooks/events/${eventId}/retry`, {
      method: 'POST',
    });
    return response.json();
  },

  // Options
  async getEventTypeOptions() {
    const response = await fetch(`${API_URL}/api/v1/webhooks/options/event-types`);
    return response.json();
  },
};

export default webhooksApi;
